module.exports = __webpack_public_path__ + "img/dog.dc3d0532.png";